<fieldset class="group">
    <legend>{{ "FLIGHT_LIST.groups.hoist" | translate }}</legend>
    @for (row of rows().controls; track $index) {
        <div class="fields accessory" [formGroup]="row">
            <span class="accessory-name">{{ labels()[$index] || "—" }}</span>
            <label class="field">
                <span class="label">{{ "FLIGHT_LIST.hoist.cycles" | translate }}</span>
                <kendo-numerictextbox formControlName="cycles" format="#" [decimals]="0" [min]="0" [spinners]="false"></kendo-numerictextbox>
            </label>
            <label class="field">
                <span class="label">{{ "FLIGHT_LIST.hoist.hours" | translate }}</span>
                <kendo-textbox formControlName="hours" placeholder="HH:MM"></kendo-textbox>
                @if (row.controls.hours.invalid) {
                    <span class="error">{{ "FLIGHT_LIST.edit.errors.duration" | translate }}</span>
                }
            </label>
        </div>
    }
</fieldset>
